import { HashRouter as Router } from 'react-router-dom';
import Landing from './Landing';

function App() {
  return (
    <Router>
      <Landing />
    </Router>
  );
}

export default App;
